import { z } from "zod";
import { TierQualificationPeriod } from "../enums";
import { moneySchema } from "./common.schema";

const tierBenefitSchema = z.object({
  id: z.string(),
  label: z.string().min(1, { message: "benefit_label_required" }),
  description: z.string().optional(),
  icon: z.string().optional(),
});

/** Validation schema for creating / editing a tier. */
export const rewardTierSchema = z.object({
  programId: z.string().min(1, { message: "program_required" }),
  name: z.string().trim().min(1, { message: "tier_name_required" }).max(60, {
    message: "max_characters_error",
  }),
  description: z.string().max(300, { message: "max_characters_error" }).optional(),
  rank: z.number().int().positive({ message: "tier_rank_invalid" }),
  icon: z.string().optional(),
  minQualifyingPoints: z
    .number()
    .int()
    .nonnegative({ message: "qualifying_points_invalid" }),
  minQualifyingSpend: moneySchema.nullable().optional(),
  qualificationPeriod: z.enum(TierQualificationPeriod),
  retentionPoints: z
    .number()
    .int()
    .nonnegative({ message: "retention_points_invalid" })
    .nullable()
    .optional(),
  benefits: z.array(tierBenefitSchema),
  pointMultiplier: z
    .number()
    .min(1, { message: "multiplier_invalid" })
    .max(10, { message: "multiplier_invalid" }),
  color: z.string().optional(),
  active: z.boolean(),
});

export type RewardTierFormValues = z.infer<typeof rewardTierSchema>;
